import { Card, CardHeader, CardBody } from '@material-tailwind/react';
import { Button } from 'antd';
import TextWinds from '../../../../components/common/TextWinds';
import { isEndDateToday } from '../../../../api/utils/util-func';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

/** 교사대학 / 클래스 카드가 공유하는 수강 정보 */
export interface CardEnrolment {
  id: string | null; // 수강 ID
  remainDays: string | null; // 수강 잔여일
  endDate: string | null; // 수강 종료일
  startDate: Date | null; // 수강 시작일
}

export { isEndDateToday };

interface ExtendButtonProps {
  onClick: () => void;
}

/** [ 기간 연장하기 ] 아웃라인 버튼 */
export const ExtendButton = ({ onClick }: ExtendButtonProps) => (
  <Button
    onClick={onClick}
    shape="round"
    size="small"
    className="shrink-0 gap-x-1 !border-red5 !text-red5 hover:!bg-red5 hover:!text-white"
  >
    기간 연장하기
    <ArrowRightIcon className="h-3.5 w-3.5" />
  </Button>
);

interface LearningCardShellProps {
  thumbnail?: string;
  name: string;
  children: React.ReactNode;
}

/** 카드 공통 외형 (썸네일 + 이름 + 본문 슬롯) */
const LearningCardShell = ({
  thumbnail,
  name,
  children,
}: LearningCardShellProps) => (
  <Card
    shadow={false}
    className="group w-full overflow-hidden rounded-lg bg-white shadow-card xl:w-[376px]"
  >
    <CardHeader
      floated={false}
      shadow={false}
      color="transparent"
      className="m-0 hidden h-[150px] rounded-none xl:block"
    >
      {thumbnail ? (
        <img
          src={thumbnail}
          alt={name}
          className="h-full w-full object-cover"
        />
      ) : (
        <img
          src={process.env.PUBLIC_URL + '/images/default_img.jpeg'}
          alt={'empty_img'}
        />
      )}
    </CardHeader>

    <CardBody className={`p-0 px-3.5 py-3`}>
      <div className="flex flex-col gap-y-2">
        <div className="flex items-center gap-x-2">
          <img
            src={process.env.PUBLIC_URL + 'images/common/icon_pencil.svg'}
            alt="pencil"
          />
          <TextWinds type="title_h4">{name}</TextWinds>
        </div>
        {children}
      </div>
    </CardBody>
  </Card>
);

export default LearningCardShell;
